import { render, staticRenderFns } from "./DokumenAseanCpa.vue?vue&type=template&id=a3445ab2&scoped=true&"
import script from "./DokumenAseanCpa.vue?vue&type=script&lang=js&"
export * from "./DokumenAseanCpa.vue?vue&type=script&lang=js&"
import style0 from "./DokumenAseanCpa.vue?vue&type=style&index=0&id=a3445ab2&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3445ab2",
  null
  
)

export default component.exports